import { updateListMethod } from '../../utils/list';
import {
  // General
  CLASS_MARKING_UPDATE_LCS_IDS,
  CLASS_MARKING_CLEAR,
  CLASS_MARKING_TOGGLE_LOADING_UNIT_OF_LEARNING_STUDENTS,
  CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS,
  CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING,
  CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING_METHOD,
  // Student view
  CLASS_MARKING_TOGGLE_LOADING_STUDENT,
  CLASS_MARKING_UPDATE_STUDENT,
  CLASS_MARKING_UPDATE_STUDENT_GRANULAR_STEP_LOG_MARKING,
  CLASS_MARKING_COMPLETED_TYPE,
  CLASS_MARKING_UPDATE_MODE,
  // Guttman chart
  CLASS_MARKING_UPDATE_VIEW_GUTTMAN_CHART,
  CLASS_MARKING_UPDATE_TYPE_GUTTMAN_CHART,

  // Bulk marking
  CLASS_MARKING_UPDATE_STEP_BULK_MARKING,
  CLASS_MARKING_UPDATE_STUDENTS_SELECTED_BULK_MARKING,
  CLASS_MARKING_UPDATE_ERROR_BULK_MARKING,
  CLASS_MARKING_UPDATE_BULK_MARKING_DATA,
  CLASS_MARKING_UPDATE_BULK_GRANULAR_STEP_LOG_MARKING,

  // Learning growth
  CLASS_MARKING_UPDATE_LEARNING_GROWTH,
  CLASS_MARKING_TOGGLE_LOADING_LEARNING_GROWTH,
  CLASS_MARKING_UPDATE_LEARNING_GROWTH_VIEW,
  CLASS_MARKING_UPDATE_LEARNING_GROWTH_TYPE,

  // Dashboard
  CLASS_MARKING_DASHBOARD_UPDATE_DASHBOARD,
  CLASS_MARKING_DASHBOARD_TOGGLE_LOADING,
  CLASS_MARKING_DASHBOARD_UPDATE_LEARNING_CONTINUUM,

  // Group marking
  CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENTS,
  CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENT,
  CLASS_MARKING_GROUP_MARKING_TOGGLE_LOADING
} from '../actions/class-marking.actions';

const initialState = {
  lcsIds: [],
  students: [],
  studentsLoading: true,

  // student view
  student: null,
  studentLoading: false,
  completedType: 'completedTeacher',
  mode: [],

  // Guttman chart
  viewGuttmanChart: 'general',
  guttmanChartType: 'completedTeacher',

  // Bulk marking
  stepBulk: 0,
  studentsBulk: [],
  errorBulk: null,
  lcs: [],
  logMarking: [],

  // Learning growth
  learningGrowth: [],
  loadingLearningGrowth: false,
  learningGrowthView: 'row',
  learningGrowthType: 'completedTeacher',

  // Dashboard
  dashboard: {
    datasets: {},
    loading: false,
    lcIds: []
  },
  // Group marking
  groupMarkingStudent: [],
  groupMarkingLoading: false
};

const classesReducer = (state = initialState, action) => {
  const newState = { ...state };
  const { type, payload } = action;

  switch (type) {
    // General
    case CLASS_MARKING_UPDATE_LCS_IDS:
      newState.lcsIds = payload;
      break;
    case CLASS_MARKING_CLEAR:
      newState.student = null;
      newState.lcsIds = [];
      newState.step = 0;
      newState.studentsBulk = [];
      newState.errorBulk = null;
      newState.viewGuttmanChart = 'general';
      newState.guttmanChartType = 'completedTeacher';
      newState.mode = [];
      newState.learningGrowth = [];
      newState.loadingLearningGrowth = false;
      newState.learningGrowthView = 'row';
      newState.learningGrowthType = 'completedTeacher';
      newState.dashboard = {
        datasets: {},
        loading: false,
        lcIds: []
      };
      newState.groupMarkingStudent = [];
      newState.groupMarkingLoading = false;
      break;
    case CLASS_MARKING_TOGGLE_LOADING_UNIT_OF_LEARNING_STUDENTS:
      newState.studentsLoading = payload;
      break;
    case CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS:
      newState.students = payload;
      break;
    case CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING:
      newState.students = newState.students.map((student) => {
        const lcs = payload.lcs.filter((lc) => String(lc.studentId) === String(student._id));

        return {
          ...student,
          lcs
        };
      });
      break;
    case CLASS_MARKING_UPDATE_UNIT_OF_LEARNING_STUDENTS_MARKING_METHOD:
      newState.students = updateListMethod(payload.method, payload.data, newState.students);
      break;
    // student view
    case CLASS_MARKING_TOGGLE_LOADING_STUDENT:
      newState.studentLoading = payload;
      break;
    case CLASS_MARKING_UPDATE_STUDENT:
      newState.student = payload;
      break;
    case CLASS_MARKING_UPDATE_STUDENT_GRANULAR_STEP_LOG_MARKING: {
      const { completed } = payload;
      const student = { ...newState.student };
      const completedLog =
        completed === 'completedTeacher'
          ? 'logMarkingTeacher'
          : completed === 'completedStudent'
            ? 'logMarkingStudent'
            : '';

      newState.student = {
        ...student,
        lcs:
          student?.lcs?.map((lc) => {
            if (String(payload.lcId) === String(lc._id)) {
              return {
                ...lc,
                updated: true,
                [completedLog]: payload.logMarking.filter((item) => String(item.lcId) === String(lc._id)),
                granularSteps: payload.granularSteps
              };
            }
            return lc;
          }) || [],
        [completedLog]: payload.logMarking
      };
      break;
    }
    case CLASS_MARKING_COMPLETED_TYPE:
      newState.completedType = payload;
      break;
    case CLASS_MARKING_UPDATE_MODE: {
      const { data, actionData } = payload;
      if (actionData === 'add') {
        newState.mode = [...newState.mode, data];
      }
      if (actionData === 'remove') {
        newState.mode = newState.mode.filter((item) => item._id !== data._id);
      }
      if (actionData === 'update') {
        newState.mode = newState.mode.map((item) => {
          if (item._id === data._id) {
            return data;
          }
          return item;
        });
      }
      break;
    }
    // Guttman chart
    case CLASS_MARKING_UPDATE_VIEW_GUTTMAN_CHART:
      newState.viewGuttmanChart = payload;
      break;
    case CLASS_MARKING_UPDATE_TYPE_GUTTMAN_CHART:
      newState.guttmanChartType = payload;
      break;

    // Bulk marking
    case CLASS_MARKING_UPDATE_STEP_BULK_MARKING:
      newState.stepBulk = payload;
      break;
    case CLASS_MARKING_UPDATE_STUDENTS_SELECTED_BULK_MARKING:
      newState.studentsBulk = payload;
      newState.errorBulk = null;
      break;
    case CLASS_MARKING_UPDATE_ERROR_BULK_MARKING:
      newState.errorBulk = payload;
      break;
    case CLASS_MARKING_UPDATE_BULK_MARKING_DATA:
      newState.lcs = payload.lcs;
      newState.logMarking = payload.logMarking;
      break;
    case CLASS_MARKING_UPDATE_BULK_GRANULAR_STEP_LOG_MARKING:
      newState.lcs = newState.lcs.map((lc) => {
        if (String(lc._id) === String(payload.lcId)) {
          return {
            ...lc,
            updated: true,
            logMarking: payload.logMarking.filter((item) => String(item.lcId) === String(payload.lcId)),
            granularSteps: payload.granularSteps
          };
        }
        return lc;
      });
      newState.logMarking = payload.logMarking.filter((item) => String(item.lcId) === String(payload.lcId));
      break;
    // Learning growth
    case CLASS_MARKING_UPDATE_LEARNING_GROWTH:
      newState.learningGrowth = payload;
      break;
    case CLASS_MARKING_TOGGLE_LOADING_LEARNING_GROWTH:
      newState.loadingLearningGrowth = payload;
      break;
    case CLASS_MARKING_UPDATE_LEARNING_GROWTH_VIEW:
      newState.learningGrowthView = payload;
      break;
    case CLASS_MARKING_UPDATE_LEARNING_GROWTH_TYPE:
      newState.learningGrowthType = payload;
      break;
    // Dashboard
    case CLASS_MARKING_DASHBOARD_UPDATE_DASHBOARD:
      newState.dashboard.datasets = payload;
      break;
    case CLASS_MARKING_DASHBOARD_TOGGLE_LOADING:
      newState.dashboard.loading = payload;
      break;
    case CLASS_MARKING_DASHBOARD_UPDATE_LEARNING_CONTINUUM:
      newState.dashboard.lcIds = payload;
      break;
    // Group marking
    case CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENTS:
      newState.groupMarkingStudent = payload;
      newState.groupMarkingLoading = false;
      break;
    case CLASS_MARKING_GROUP_MARKING_UPDATE_STUDENT: {
      const find = newState.groupMarkingStudent.find(
        (item) => item.studentId === payload.studentId && item.lcId === payload.lcId
      );
      if (find) {
        newState.groupMarkingStudent = newState.groupMarkingStudent.map((item) => {
          if (item.studentId === payload.studentId && item.lcId === payload.lcId) {
            return payload;
          }
          return item;
        });
      } else {
        newState.groupMarkingStudent = [...newState.groupMarkingStudent, payload];
      }
      break;
    }
    case CLASS_MARKING_GROUP_MARKING_TOGGLE_LOADING:
      newState.groupMarkingLoading = payload;
      break;
    default:
      break;
  }

  return newState;
};

export default classesReducer;
